import React from 'react';
import PropTypes from 'prop-types';

const ProfileDetails = ({ employee }) => {
  if (!employee) return null;
  
  // Helper function to format comma-separated values
  const formatCommaSeparatedValue = (value) => {
    if (!value) return '';
    
    // If it's already a string with commas, return as is
    if (typeof value === 'string' && value.includes(',')) {
      return value;
    }
    
    // If it's a string without commas, try to intelligently split it
    if (typeof value === 'string') {
      // Look for common city/location patterns and add commas
      // This regex looks for capital letters that indicate new words/locations
      const formatted = value.replace(/([a-z])([A-Z])/g, '$1, $2');
      return formatted;
    }
    
    // If it's an array, join with commas
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    
    return value;
  };
  
  return (
    <div className="profile-basic-details">
      <div className="info-row">
        <span className="info-label">Employee ID:</span>
        <span className="infos-value">{employee.emp_id}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Email:</span>
        <span className="infos-value">{employee.email_id}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Role:</span>
        <span className="infos-value">{employee.role}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Location:</span>
        <span className="infos-value">{formatCommaSeparatedValue(employee.location)}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Branch:</span>
        <span className="infos-value">{formatCommaSeparatedValue(employee.branch)}</span>
      </div>
    </div>
  );
};

ProfileDetails.propTypes = {
  employee: PropTypes.object
};

export default ProfileDetails;